import api_external from "tools/api_external";
import { EndpointListExteral } from "tools/config_external";

export const AuthService = api_external.injectEndpoints({
  endpoints: (build) => ({
    getQuranPages: build.query<any, any>({
      query: (page) =>
        `${EndpointListExteral.PAGE}${page}/${EndpointListExteral.LANGUAGE}`,
      transformResponse: (response: any) => {
        const groupedBySurah = (response?.data?.ayahs || []).reduce(
          (result: any, ayah: any) => {
            const surahNumber = ayah.surah.number;
            const existingSurah = result.find(
              (surah: any) => surah.number === surahNumber
            );

            if (existingSurah) {
              existingSurah.ayahs.push(ayah);
            } else {
              result.push({
                ...ayah?.surah,
                ayahs: [ayah],
              });
            }

            return result;
          },
          []
        );

        return groupedBySurah;
      },
    }),
    getSingleAyah: build.query<any, any>({
      query: (number) =>
        `${EndpointListExteral.AYAH}/${number}/${EndpointListExteral.LANGUAGE_ALAFASY}`,
      // providesTags: [],
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetQuranPagesQuery,
  useGetQuranPagesQuery,
  useLazyGetSingleAyahQuery,
} = AuthService;
